export default "__VITE_ASSET__EgX6HRbU__"